import React from "react";
import { StyledEmptyState } from "./EmptyState.styled";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import { theme } from "../../constants/StyledComponents";

type EmptyStateProps = {
  label: string;
  children?: React.ReactNode;
  imageSrc: string;
  maxWidth?: number;
};

export const EmptyState = ({
  label,
  children,
  imageSrc,
  maxWidth,
}: EmptyStateProps) => {
  return (
    <StyledEmptyState $maxWidth={maxWidth}>
      <img alt="empty-state" src={imageSrc} />
      <div className="label-div">
        <BodyTyp
          variant="2"
          fontWeight={FontWeightEnum.MEDIUM}
          color={theme.colors.black}
        >
          {label}
        </BodyTyp>
      </div>
      {children}
    </StyledEmptyState>
  );
};
